export class AppReadyEvent {
  constructor(public ready: boolean) {}
}
